'use client'

import {Pagination as KitPagination, PaginationProps} from 'antd'
import React, {useEffect, useState} from 'react'

import * as UI from './pagination.styled'

export type Props = PaginationProps

export const Pagination = (props: Props) => {
  return (
    <UI.Pagination
      {...props}
      as={KitPagination}
      align="center"
      defaultCurrent={1}
      showTitle={false}
      showSizeChanger={false}
      showQuickJumper={false}
      showLessItems={false}
      responsive
    />
  )
}

export interface PaginationOptionsProps {
  items?: number[]
  perPage?: number
  className?: string
  onChange?: (perPage: number) => void | Promise<void>
}

export const PaginationOptions = ({
  className,
  onChange,
  perPage: perPageDefault = 20,
  items = [20, 40, 60, 100],
}: PaginationOptionsProps) => {
  if (!items.includes(perPageDefault)) {
    perPageDefault = items[0]!
  }

  const [perPage, setPerPage] = useState(perPageDefault)

  useEffect(() => {
    if (!items.includes(perPageDefault)) {
      perPageDefault = items[0]!
    }
    setPerPage(perPageDefault)
  }, [perPageDefault])

  if (items.length === 0) {
    throw new Error('items: нужно передать хотя-бы одно число')
  }

  return (
    <UI.PerPageOptions className={className}>
      <span>Отображать по</span>
      {items.map(perPageItem => (
        <UI.PerPage
          key={perPageItem}
          $active={perPageItem == perPage}
          onClick={() => {
            setPerPage(perPageItem)
            if (onChange) {
              onChange(perPageItem)
            }
          }}>
          <span>{perPageItem}</span>
        </UI.PerPage>
      ))}
    </UI.PerPageOptions>
  )
}
